<h2 class="text-xl font-bold text-gray-800 text-center">
    🎨 Générer une image dynamique
</h2>

<!-- Texte -->
<div class="space-y-2">
    <label class="block text-sm font-medium text-gray-700">📝 Texte à afficher</label>
    <textarea [(ngModel)]="fullText" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"></textarea>
</div>

<!-- URL -->
<div class="space-y-2">
    <label class="block text-sm font-medium text-gray-700">🔗 URL à encoder (QRCode)</label>
    <input type="text" [(ngModel)]="url" class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm" />
</div>

<button (click)="generateDynamicTemplate()" class="bg-blue-600 text-white px-4 py-2 rounded">
    🎨 Générer le PNG
</button>

<canvas #canvas hidden></canvas>

<a #downloadLink class="block text-blue-600 underline mt-4" [href]="imageData" download="template.png" *ngIf="imageData">
    📥 Télécharger l'image générée
</a>

<button (click)="sendToBackend()" class="bg-blue-600 text-white px-4 py-2 rounded">
    Send to backend
</button>
